import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Avatar component with a text fallback if image fails to load
 */
const AvatarWithFallback = ({ 
  name, 
  src, 
  bgColor = '#1976d2',
  size = 36,
  fontSize = 16,
  sx = {}
}) => {
  const [imgError, setImgError] = useState(false);
  
  // Get first letter for fallback
  const firstLetter = name?.charAt(0)?.toUpperCase() || 'A';
  
  // Handle image error
  const handleError = () => {
    setImgError(true);
  };
  
  return imgError ? (
    // Fallback avatar with first letter
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: bgColor,
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: fontSize,
        ...sx
      }}
    >
      <Typography variant="inherit">{firstLetter}</Typography>
    </Box>
  ) : (
    // Image avatar
    <Box
      component="img"
      src={src}
      alt={name}
      onError={handleError}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        borderRadius: '50%',
        ...sx
      }}
    />
  );
};

export default AvatarWithFallback;